import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import { plpType } from 'Models/plpType'
import plpService from 'Services/plpService'
import { BreadCrumb, ModalWrapper } from 'Components'
import { Key, useEffect, useRef, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import './TradersCardDetails.scss'
import Modal from 'react-bootstrap/esm/Modal'
import { formatString } from 'Helpers/formatString'
import { handleError } from 'Helpers'
import { ToastContainer } from 'react-toastify'
// import uploadDocumentService from 'Services/uploadDocumentService'
import Swal from 'sweetalert2'
// import LeaseAssetService from 'Services/leaseAssetServices'
// import { LeaseAssetsType } from 'Models'
import TradersCardUpdateForm from './TradersCardUpdateForm'
// import { set } from 'date-fns'

const TradersCardDetails = () => {
  const { referenceId } = useParams()
  const [plpData, setPlpData] = useState<plpType>()
  const [aprovalReq, setAprovalReq] = useState(false)

  const [showModal, setShowModal] = useState(false)
  const [showUpdateModal, setShowUpdateModal] = useState(false)

  const { showAlert } = ShowTGAlert()

  const [previewUrl, setPreviewUrl] = useState<string | undefined>()
  const [previewType, setPreviewType] = useState<'image' | 'pdf'>('image')

  const [selectedDocId, setSelectedDocId] = useState<string>()
  const [rejectionReason, setRejectionReason] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const [selectedAssetID, setselectedAaaetID] = useState('')

  const getPlpDetails = async () => {
    await plpService.getDetails(referenceId).then(
      (response) => {
        console.log('getPlpDetails', response.data.data)
        setPlpData(response.data.data)
      },
      (error: { response: { data: { error: string } } }) => {
        console.log('getPlpDetails error', error.response)
      },
    )
  }

  const transformFileUploadCategory = (fileUploadCategory: string): string => {
    if (fileUploadCategory === 'PLP_APPLICATION_ID') {
      return 'Identification'
    } else if (fileUploadCategory === 'PLP_APPLICATION_CAC_CERTIFICATE') {
      return 'CTC of CAC Registration form'
    } else if (fileUploadCategory === 'PLP_APPLICATION_CTC_OF_CAC_REGISTRATION_FORM') {
      return 'CTC of CAC Registration form'
    } else if (fileUploadCategory === 'PLP_APPLICATION_CAC_7') {
      return 'CAC 7'
    } else if (fileUploadCategory === 'PLP_APPLICATION_MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION') {
      return 'Memorandum and articles of association'
    } else if (fileUploadCategory === 'PLP_APPLICATION_RECENT_UTILITY_BILL') {
      return 'Recent Utility bill'
    } else if (fileUploadCategory === 'PLP_APPLICATION_COMPANY_BANK_STATEMENT_LAST_12_MONTHS') {
      return 'Company bank statement in last 12 months'
    } else if (fileUploadCategory === 'PLP_APPLICATION_DEPARTMENT_OF_PETROLEUM_RESOURCES_LICENSE') {
      return 'Department of petroleum resources license'
    } else if (
      fileUploadCategory === 'PLP_APPLICATION_FILLING_STATION_REAL_OWNER_LEASE_AGREEMENT'
    ) {
      return 'Filling station real owner lease agreement'
    } else if (fileUploadCategory === 'STATION_LEASE_DOCUMENTS') {
      return 'Station lease documents'
    }
    return 'Unknown file upload category'
  }

  useEffect(() => {
    getPlpDetails()
  }, [])

  const submitApproval = async (aproval: string) => {
    let reason: string | undefined = undefined
    if (aproval === 'reject') {
      const { value: rejectionReason } = await Swal.fire({
        html: '<h2 style="font-size:1.3rem; margin:0">Reject Traders Card</h2>',
        input: 'textarea',
        inputLabel: 'Rejection reason',
        inputPlaceholder: 'Provide a reason for rejecting this Traders Card',
        showCancelButton: true,
        confirmButtonText: 'Submit',
        cancelButtonText: 'No, cancel',
        inputValidator: (value) => {
          if (!value || !value.trim()) return 'Please provide a rejection reason'
          return null
        },
      })

      reason = rejectionReason

      if (!reason) return
    }

    setAprovalReq(true)
    await plpService.aproval(referenceId, aproval, reason).then(
      (response) => {
        console.log('getPlpDetails', response)
        setAprovalReq(false)
        showAlert({
          message: `Traders Card ${aproval} successfully`,
          show: true,
          title: 'Success',
          type: 'success',
        })

        setTimeout(() => {
          getPlpDetails()
        }, 3000)
      },
      (error: { response: { data: { error: string } } }) => {
        setAprovalReq(false)
        console.log('getPlpDetails error', error.response)
        showAlert({ message: error.response.data.error, show: true, title: 'Error', type: 'error' })
      },
    )
  }

  const [approvingRequest, setApprovingRequest] = useState(false)
  const [value, setValue] = useState(0)

  const submitCardApproval = async (e: { preventDefault: () => void }) => {
    e.preventDefault()
    setApprovingRequest(true)

    await plpService.cardApproval(referenceId, value).then(
      (response) => {
        console.log('getPlpDetails', response)

        showAlert({
          message: 'Traders Card approved successfully',
          show: true,
          title: 'Success',
          type: 'success',
        })
        // submitAssignToStation()

        setApprovingRequest(false)
        setShowModal(false)
        showAlert({
          message: 'Traders Card added to station lease asset successfully',
          show: true,
          title: 'Success',
          type: 'success',
        })

        getPlpDetails()
      },
      (error: { response: { data: { error: string } } }) => {
        setApprovingRequest(false)
        console.log('getPlpDetails error', error.response)
        showAlert({ message: error.response.data.error, show: true, title: 'Error', type: 'error' })
      },
    )
  }

  // const submitAssignToStation = async () => {
  //   if (!referenceId) return

  //   setApprovingRequest(true)
  //   await plpService.assignStation(referenceId, selectedAssetID).then(
  //     () => {
  //       setApprovingRequest(false)
  //       setShowModal(false)
  //       showAlert({
  //         message: 'Traders Card added to station lease asset successfully',
  //         show: true,
  //         title: 'Success',
  //         type: 'success',
  //       })
  //     },
  //     (error: { response: { data: { error: string } } }) => {
  //       showAlert({
  //         message: error.response.data.error,
  //         show: true,
  //         title: 'Error',
  //         type: 'error',
  //       })
  //       setApprovingRequest(false)
  //     },
  //   )
  // }

  // const handleApprove = async (docId: string) => {
  //   setSubmitting(true)
  //   await plpService.approveDocument(referenceId, docId).then(
  //     () => {
  //       setSubmitting(false)
  //       handleSuccess('Document approved successfully')
  //       setSelectedDocId(undefined)
  //     },
  //     (error: { response?: { data?: { error: string } } }) => {
  //       setSubmitting(false)
  //       handleError(error)
  //     },
  //   )
  // }

  const openRejectModal = (docId: string) => {
    setSelectedDocId(docId)
    setRejectionReason('')
  }

  const handleReject = async () => {
    if (!rejectionReason.trim()) {
      handleError({ response: { data: { error: 'Please provide a rejection reason' } } })
      return
    }

    setSubmitting(true)

    await plpService.rejectDocument(referenceId!, rejectionReason, selectedDocId).then(
      () => {
        setSubmitting(false)

        showAlert({
          message: 'Document rejected',
          show: true,
          title: 'Success',
          type: 'success',
        })

        setSelectedDocId(undefined)
      },
      (error) => {
        setSubmitting(false)
        showAlert({ message: error.response.data.error, show: true, title: 'Error', type: 'error' })
      },
    )
  }

  const openPreview = (url: string) => {
    const isPdf = url.toLowerCase().endsWith('.pdf')
    setPreviewType(isPdf ? 'pdf' : 'image')
    setPreviewUrl(url)
  }

  const closePreview = () => {
    setPreviewUrl(undefined)
  }

  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const [uploading, setUploading] = useState(false)

  const [files, setFiles] = useState<File[]>([])

  const handleCardClick = () => {
    fileInputRef.current?.click()
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return
    if (files.length === 5) alert('Maximum limit of 5 files reached')

    const selected = Array.from(e.target.files)
    const combined = [...files, ...selected].slice(0, 5)

    setFiles(combined)
  }

  // const saveFile = async () => {
  //   if (!file) return
  //   const formData = new FormData()
  //   // Update the formData object
  //   formData.append('file', file)

  //   setUploading(true)

  //   await uploadDocumentService
  //     .upload('PLP_APPLICATION_LEASE_AGREEMENT_VALIDITY_DOCUMENT', referenceId, formData)
  //     .then(
  //       () => {
  //         Swal.fire({
  //           icon: 'success',
  //           title: 'Congratulations!',
  //           text: 'TradeGrid Plus application request submitted successfully',
  //           showConfirmButton: false,
  //           timer: 3000,
  //         })
  //         setUploading(false)
  //       },
  //       (error: { response: { data: { error: string } } }) => {
  //         setUploading(false)
  //         Swal.fire({
  //           icon: 'warning',
  //           title: 'Oops!',
  //           text: error.response.data.error,
  //           showConfirmButton: false,
  //           timer: 3000,
  //         })
  //       },
  //     )
  // }

  const removeFile = (index: number) => {
    setFiles((prev) => prev.filter((_, i) => i !== index))
  }

  const saveFile = async () => {
    if (!files.length || !referenceId) return

    setUploading(true)
    try {
      // upload files one at a time (sequentially)
      for (const file of files) {
        const formData = new FormData()
        formData.append('file', file)

        await plpService.leaseFileUpload(referenceId, formData)
      }

      Swal.fire({
        icon: 'success',
        title: 'Congratulations!',
        text: 'All files uploaded successfully',
        showConfirmButton: false,
        timer: 3000,
      })

      setFiles([])
    } catch (error: any) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops!',
        text: error?.response?.data?.error ?? 'An error occurred while uploading files',
        showConfirmButton: false,
        timer: 3000,
      })
    } finally {
      setUploading(false)
    }
  }

  // const [assets, setAssets] = useState<LeaseAssetsType[]>([])

  // const getAssets = async () => {
  //   await LeaseAssetService.getAllList(1, 'DESC', 'ALL').then((response) => {
  //     setAssets(response?.data.data.dataset)
  //   })
  // }

  // useEffect(() => {
  //   getAssets()
  // }, [])

  return (
    <div className='tradersCardDetails mb-5 px-3 px-lg-0'>
      {' '}
      <div className='container mt-4'>
        <BreadCrumb
          title={'Details'}
          parent={'Traders Card'}
          parentUrl={'-1'}
          showTitle={false}
        ></BreadCrumb>
        <div className='row mt-3'>
          <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-8 my-auto'>
            <div className='title'>
              {plpData?.companyName} Traders Card Application{' '}
              {plpData?.plpApplicationVerified === 'APPROVED' ? (
                <span className='status-approved'>{plpData?.plpApplicationVerified}</span>
              ) : (
                <span className='status-pending'>{plpData?.plpApplicationVerified}</span>
              )}
            </div>
          </div>

          <div className='col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 text-md-end d-flex mt-3 mt-lg-0'>
            {aprovalReq && (
              <button className='btn btn-respond-req'>
                <span className='spinner-border spinner-border-sm'></span>
              </button>
            )}
            {!aprovalReq && plpData?.plpApplicationVerified !== 'REJECTED' && (
              <button className='btn btn-decline' onClick={() => submitApproval('reject')}>
                Decline
              </button>
            )}

            {!aprovalReq && plpData?.plpApplicationVerified !== 'APPROVED' && (
              <button className='btn btn-approve ms-3' onClick={() => setShowModal(true)}>
                Approve
              </button>
            )}
            <button className='btn btn-decline ms-3' onClick={() => setShowUpdateModal(true)}>
              Edit
            </button>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-7'>
            <div className='sub-title mb-2 mt-4'>Company details</div>
            <div className='card border-0'>
              <div className='card-body'>
                <div className='row'>
                  <div className='col-6 col-md-4 list-item'>
                    <div className='label'>Customer</div>
                    <div className='value'>
                      {plpData?.customer.firstName}
                      {plpData?.customer.lastName}
                    </div>
                  </div>
                  <div className='col-6 col-md-4  list-item'>
                    <div className='label'>Registration Type</div>
                    <div className='value'>{plpData?.businessRegistrationType ?? '-'}</div>
                  </div>
                  <div className='col-6 col-md-4  list-item'>
                    <div className='label'> Company State </div>
                    <div className='value'>{plpData?.companyState ?? '-'}</div>
                  </div>
                  <div className='col-6 col-md-4  list-item'>
                    <div className='label'>Company L.G.A</div>
                    <div className='value'>{plpData?.companyLGA ?? '-'}</div>
                  </div>
                  <div className='col-6 col-md-4  list-item'>
                    <div className='label'>BVN</div>
                    <div className='value'>
                      {plpData?.kycData ? (plpData?.kycData?.BVN ?? '*********') : '**********'}
                    </div>
                  </div>
                  <div className='col-6 col-md-4  list-item'>
                    <div className='label'>NIN</div>
                    <div className='value'>
                      {plpData?.kycData ? (plpData?.kycData?.NIN ?? '*********') : '**********'}
                    </div>
                  </div>
                  <div className='col-6 col-md-4  list-item'>
                    <div className='label'>CAC Number</div>
                    <div className='value'>{plpData?.cacNumber ?? '-'}</div>
                  </div>
                  {/* <div className='col-6 col-md-4  list-item'>
                    <div className='label'>Company Daily Sales Capacity </div>
                    <div className='value'>{plpData?.dailySalesCapacity ?? '-'}</div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className='col-md-5'>
            <div className='sub-title mb-2 mt-4'>Lease Agreement Validity</div>

            <div className='d-flex justify-content-center'>
              <div className='card border-0 file-card'>
                <div className='card-body text-center d-flex flex-column align-items-center justify-content-center'>
                  <div className='add-file' onClick={handleCardClick}>
                    +
                  </div>

                  {files.length ? (
                    <div className='label w-100'>
                      {files.map((file, index) => (
                        <div
                          key={index}
                          className='d-flex justify-content-between align-items-center mb-1'
                        >
                          <span>{file.name}</span>
                          <button
                            type='button'
                            className='btn btn-sm btn-danger'
                            onClick={() => removeFile(index)}
                            disabled={uploading}
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className='label'>Upload Files (Max. 5 docs)</div>
                  )}

                  {/* {files.length ? (
                    <div className='label'>
                      {files.map((file, index) => (
                        <div key={index}>{file.name}</div>
                      ))}
                    </div>
                  ) : (
                    <div className='label'>Upload Files (Max. 5 docs)</div>
                  )} */}

                  {files.length > 0 && (
                    <button
                      type='button'
                      className='btn btn-default mt-2'
                      onClick={saveFile}
                      disabled={uploading}
                    >
                      Upload{' '}
                      {uploading && <span className='spinner-border spinner-border-sm'></span>}
                    </button>
                  )}
                </div>

                <input
                  ref={fileInputRef}
                  type='file'
                  className='d-none'
                  multiple
                  accept='image/*,.pdf'
                  onChange={handleFileChange}
                />
              </div>
            </div>
          </div>

          <div className='col-md-12'>
            <div className='sub-title mb-2 mt-4'>Uploaded Legal Documents</div>
            <div className='card border-0 py-3'>
              <div className='card-body'>
                <div className='row'>
                  {plpData?.verificationDocuments &&
                    plpData.verificationDocuments.map((docs, index: Key) => {
                      return (
                        <div className='col-6 col-md-4 mt-4 col-xl-3 mb-5' key={index}>
                          <div className='row'>
                            <div className='col-12 col-md-12'>
                              <div className='image-card'>
                                <img src={docs.url} className='w-100'></img>
                                <div className='d-flex'>
                                  <button className='btn' onClick={() => openPreview(docs.url)}>
                                    <svg
                                      width='23'
                                      height='23'
                                      viewBox='0 0 23 23'
                                      fill='none'
                                      xmlns='http://www.w3.org/2000/svg'
                                    >
                                      <path
                                        d='M11.433 15.5585C9.15596 15.5585 7.30762 13.7101 7.30762 11.433C7.30762 9.15596 9.15596 7.30762 11.433 7.30762C13.7101 7.30762 15.5585 9.15596 15.5585 11.433C15.5585 13.7101 13.7101 15.5585 11.433 15.5585ZM11.433 8.73675C9.94675 8.73675 8.73675 9.94675 8.73675 11.433C8.73675 12.9193 9.94675 14.1293 11.433 14.1293C12.9193 14.1293 14.1293 12.9193 14.1293 11.433C14.1293 9.94675 12.9193 8.73675 11.433 8.73675Z'
                                        fill='#292D32'
                                      />
                                      <path
                                        d='M11.433 20.0266C7.85068 20.0266 4.46839 17.9305 2.14367 14.291C1.13375 12.7189 1.13375 10.156 2.14367 8.57445C4.47792 4.93493 7.8602 2.83887 11.433 2.83887C15.0059 2.83887 18.3882 4.93493 20.7129 8.57445C21.7228 10.1465 21.7228 12.7094 20.7129 14.291C18.3882 17.9305 15.0059 20.0266 11.433 20.0266ZM11.433 4.268C8.35564 4.268 5.41162 6.11635 3.35367 9.34619C2.6391 10.4609 2.6391 12.4045 3.35367 13.5193C5.41162 16.7491 8.35564 18.5974 11.433 18.5974C14.5104 18.5974 17.4545 16.7491 19.5124 13.5193C20.227 12.4045 20.227 10.4609 19.5124 9.34619C17.4545 6.11635 14.5104 4.268 11.433 4.268Z'
                                        fill='#292D32'
                                      />
                                    </svg>
                                  </button>

                                  <Link
                                    to={docs.url}
                                    // target='_blank'
                                    // rel='noreferrer'
                                    download={true}
                                  >
                                    <button className='btn'>
                                      <svg
                                        width='20'
                                        height='20'
                                        viewBox='0 0 23 23'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                      >
                                        <path
                                          d='M8.57492 16.9113C8.47964 16.9113 8.39389 16.8922 8.29862 16.8541C8.03185 16.7493 7.86035 16.4826 7.86035 16.1967V10.4802C7.86035 10.0896 8.18429 9.76562 8.57492 9.76562C8.96555 9.76562 9.28948 10.0896 9.28948 10.4802V14.4722L9.97547 13.7863C10.2518 13.51 10.7091 13.51 10.9854 13.7863C11.2617 14.0626 11.2617 14.5199 10.9854 14.7962L9.07988 16.7017C8.94649 16.8351 8.75594 16.9113 8.57492 16.9113Z'
                                          fill='#292D32'
                                        />
                                        <path
                                          d='M8.57473 16.9114C8.3937 16.9114 8.21268 16.8447 8.06977 16.7018L6.16426 14.7962C5.88796 14.5199 5.88796 14.0626 6.16426 13.7863C6.44055 13.51 6.89788 13.51 7.17418 13.7863L9.07969 15.6918C9.35599 15.9681 9.35599 16.4255 9.07969 16.7018C8.93677 16.8447 8.75575 16.9114 8.57473 16.9114Z'
                                          fill='#292D32'
                                        />
                                        <path
                                          d='M14.2913 21.6756H8.57477C3.40131 21.6756 1.19092 19.4653 1.19092 14.2918V8.57526C1.19092 3.4018 3.40131 1.19141 8.57477 1.19141H13.3385C13.7292 1.19141 14.0531 1.51534 14.0531 1.90597C14.0531 2.2966 13.7292 2.62054 13.3385 2.62054H8.57477C4.18257 2.62054 2.62005 4.18306 2.62005 8.57526V14.2918C2.62005 18.684 4.18257 20.2465 8.57477 20.2465H14.2913C18.6835 20.2465 20.246 18.684 20.246 14.2918V9.52802C20.246 9.13739 20.57 8.81345 20.9606 8.81345C21.3512 8.81345 21.6752 9.13739 21.6752 9.52802V14.2918C21.6752 19.4653 19.4648 21.6756 14.2913 21.6756Z'
                                          fill='#292D32'
                                        />
                                        <path
                                          d='M20.9606 10.2422H17.1496C13.8912 10.2422 12.624 8.97499 12.624 5.71656V1.90554C12.624 1.61972 12.7955 1.35294 13.0623 1.24814C13.3291 1.13381 13.6339 1.2005 13.8436 1.40058L21.4656 9.02263C21.6657 9.2227 21.7324 9.53711 21.618 9.80388C21.5037 10.0707 21.2465 10.2422 20.9606 10.2422ZM14.0532 3.63003V5.71656C14.0532 8.17467 14.6915 8.81302 17.1496 8.81302H19.2361L14.0532 3.63003Z'
                                          fill='#292D32'
                                        />
                                      </svg>
                                    </button>
                                  </Link>
                                </div>
                              </div>{' '}
                            </div>

                            <div className='col-4 col-md-4 my-auto d-none'>
                              <div className='d-md-flex'>
                                <button
                                  className='btn me-3 btn-decline py-1 mb-2 mb-md-0'
                                  onClick={() => openRejectModal(docs.fileCategory)}
                                >
                                  Decline
                                </button>

                                {/* <button
                                  className='btn btn-approve py-1'
                                  disabled={submitting}
                                  onClick={() => handleApprove(docs.fileCategory)}
                                >
                                  Approve
                                </button> */}
                              </div>
                            </div>
                          </div>

                          <div className='image-card-title'>{formatString(docs.fileCategory)}</div>

                          <button
                            className='btn me-3 btn-decline py-1 mb-2 mb-md-0'
                            onClick={() => openRejectModal(docs.fileCategory)}
                          >
                            Decline
                          </button>
                        </div>
                      )
                    })}
                </div>
              </div>
            </div>
          </div>
          {plpData?.stationLeaseDocuments && (
            <div className='col-md-12'>
              <div className='sub-title mb-2 mt-4'>Lease Agreement Validity Documents</div>
              <div className='card border-0 py-3'>
                <div className='card-body'>
                  <div className='row'>
                    {plpData?.stationLeaseDocuments.map((res, index) => {
                      return (
                        <div className='col-6 col-md-4 mt-4 col-xl-2' key={index}>
                          <div className='uploadedDocument'>
                            <img src={res.url} className='w-100 rounded'></img>

                            <div className='icons'>
                              <button className='btn' onClick={() => openPreview(res.url)}>
                                <svg
                                  width='18'
                                  height='18'
                                  viewBox='0 0 24 24'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M11.9999 16.3319C9.60992 16.3319 7.66992 14.3919 7.66992 12.0019C7.66992 9.61187 9.60992 7.67188 11.9999 7.67188C14.3899 7.67188 16.3299 9.61187 16.3299 12.0019C16.3299 14.3919 14.3899 16.3319 11.9999 16.3319ZM11.9999 9.17188C10.4399 9.17188 9.16992 10.4419 9.16992 12.0019C9.16992 13.5619 10.4399 14.8319 11.9999 14.8319C13.5599 14.8319 14.8299 13.5619 14.8299 12.0019C14.8299 10.4419 13.5599 9.17188 11.9999 9.17188Z'
                                    fill='#292D32'
                                  />
                                  <path
                                    d='M12.0001 21.0205C8.24008 21.0205 4.69008 18.8205 2.25008 15.0005C1.19008 13.3505 1.19008 10.6605 2.25008 9.00047C4.70008 5.18047 8.25008 2.98047 12.0001 2.98047C15.7501 2.98047 19.3001 5.18047 21.7401 9.00047C22.8001 10.6505 22.8001 13.3405 21.7401 15.0005C19.3001 18.8205 15.7501 21.0205 12.0001 21.0205ZM12.0001 4.48047C8.77008 4.48047 5.68008 6.42047 3.52008 9.81047C2.77008 10.9805 2.77008 13.0205 3.52008 14.1905C5.68008 17.5805 8.77008 19.5205 12.0001 19.5205C15.2301 19.5205 18.3201 17.5805 20.4801 14.1905C21.2301 13.0205 21.2301 10.9805 20.4801 9.81047C18.3201 6.42047 15.2301 4.48047 12.0001 4.48047Z'
                                    fill='#292D32'
                                  />
                                </svg>
                              </button>
                              <a href={res.url} target='_blank' rel='noreferrer' download>
                                <button className='btn'>
                                  <svg
                                    width='18'
                                    height='18'
                                    viewBox='0 0 24 24'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      d='M9 17.75C8.9 17.75 8.81 17.73 8.71 17.69C8.43 17.58 8.25 17.3 8.25 17V11C8.25 10.59 8.59 10.25 9 10.25C9.41 10.25 9.75 10.59 9.75 11V15.19L10.47 14.47C10.76 14.18 11.24 14.18 11.53 14.47C11.82 14.76 11.82 15.24 11.53 15.53L9.53 17.53C9.39 17.67 9.19 17.75 9 17.75Z'
                                      fill='#292D32'
                                    />
                                    <path
                                      d='M9.00043 17.7514C8.81043 17.7514 8.62043 17.6814 8.47043 17.5314L6.47043 15.5314C6.18043 15.2414 6.18043 14.7614 6.47043 14.4714C6.76043 14.1814 7.24043 14.1814 7.53043 14.4714L9.53043 16.4714C9.82043 16.7614 9.82043 17.2414 9.53043 17.5314C9.38043 17.6814 9.19043 17.7514 9.00043 17.7514Z'
                                      fill='#292D32'
                                    />
                                    <path
                                      d='M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z'
                                      fill='#292D32'
                                    />
                                    <path
                                      d='M22 10.7485H18C14.58 10.7485 13.25 9.41852 13.25 5.99852V1.99852C13.25 1.69852 13.43 1.41852 13.71 1.30852C13.99 1.18852 14.31 1.25852 14.53 1.46852L22.53 9.46852C22.74 9.67852 22.81 10.0085 22.69 10.2885C22.57 10.5685 22.3 10.7485 22 10.7485ZM14.75 3.80852V5.99852C14.75 8.57852 15.42 9.24852 18 9.24852H20.19L14.75 3.80852Z'
                                      fill='#292D32'
                                    />
                                  </svg>
                                </button>
                              </a>
                            </div>
                          </div>
                          <div className='doc-name mt-4'>
                            {transformFileUploadCategory(res.fileCategory)}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        container={() =>
          (document.querySelector('.tradersCardDetails') as HTMLElement | null) ?? document.body
        }
        contentClassName='asset-valuation-modal'
      >
        <div className='asset-valuation-modal__header'>
          <div className='asset-valuation-modal__title'>Asset Valuation</div>
          <button
            type='button'
            className='asset-valuation-modal__close'
            onClick={() => setShowModal(false)}
            aria-label='Close'
          >
            ×
          </button>
        </div>
        <div className='asset-valuation-modal__divider' />

        <form className='asset-valuation-modal__content' onSubmit={submitCardApproval}>
          <div className='asset-valuation-modal__field w-100'>
            <div className='asset-valuation-modal__label'>Asset Valuation</div>
            <input
              type='number'
              value={value === 0 ? '' : value}
              onChange={(e) => setValue(Number(e.target.value))}
              className='asset-valuation-modal__input w-100'
              placeholder='₦5,000,000.00'
            />
          </div>

          <button
            className='asset-valuation-modal__confirm'
            type='submit'
            disabled={approvingRequest}
          >
            Confirm Approval
            {approvingRequest ? <span className='spinner-border spinner-border-sm'></span> : null}
          </button>
        </form>
      </Modal>
      <ModalWrapper
        showModal={selectedDocId != undefined}
        closeModal={() => setSelectedDocId(undefined)}
        title='Reject Document'
        hideHeader={false}
      >
        <label className='form-label'>Rejection Reason</label>
        <textarea
          className='form-control'
          rows={4}
          value={rejectionReason}
          onChange={(e) => setRejectionReason(e.target.value)}
          placeholder='Explain why this document is rejected'
        />

        <button
          className='btn btn-secondary btn-default bg-white text-dark px-4 mt-4 me-3'
          onClick={() => setSelectedDocId(undefined)}
        >
          Cancel
        </button>

        <button
          className='btn btn-danger btn-default mt-4'
          disabled={submitting}
          onClick={handleReject}
        >
          Reject Document {submitting && <span className='spinner-border spinner-border-sm'></span>}
        </button>
      </ModalWrapper>
      <ModalWrapper
        showModal={previewUrl != undefined}
        closeModal={() => closePreview()}
        title='Document Preview'
        hideHeader={false}
        size={'xl'}
      >
        {previewType === 'image' ? (
          <img
            src={previewUrl}
            alt='Preview'
            className='img-fluid rounded'
            style={{ maxHeight: '75vh' }}
          />
        ) : (
          <iframe src={previewUrl} title='PDF Preview' width='100%' height='600px'></iframe>
        )}
      </ModalWrapper>
      <ModalWrapper
        showModal={showUpdateModal}
        closeModal={function (): void {
          setShowUpdateModal(false)
        }}
        title={'Update TradersCard'}
        hideHeader={false}
      >
        <TradersCardUpdateForm
          plp={plpData as plpType}
          onSucess={() => {
            getPlpDetails()
            setShowUpdateModal(false)
          }}
        ></TradersCardUpdateForm>
      </ModalWrapper>
      <ToastContainer></ToastContainer>
    </div>
  )
}

export default TradersCardDetails
